export const examTypes = ['수능', '3월 모의고사', '5월 모의고사', '6월 모의고사', '7월 모의고사', '9월 모의고사', '10월 모의고사'];

export const subjects = ['수학', '수학(가형)', '수학(나형)', '미적분', '확률과 통계', '기하'];

export const chapters = [
  '지수와 로그',
  '삼각함수',
  '수열',
  '함수의 극한과 연속',
  '미분',
  '적분',
  '수열의 극한',
  '미분법',
  '적분법',
  '경우의 수',
  '확률',
  '통계',
  '이차곡선',
  '평면벡터',
  '공간도형과 공간좌표',
];

export const problemTypes = ['개념 이해', '계산', '증명', '응용', '실생활 활용', '도형·그래프', '융합형'];